import { Dispatch } from 'redux';
import { LoginService } from '../../services/LoginService';
 import {  MEOFFICER_API, FNOFFICER_API,SUPRIVISOR_API} from '../../ApiNames';


export const fetchAct = (data: any) => ({
    type: 'FETCH_GET_SUCCESS',
    payload: data,
});
export const fetch = (header: any) => ({
    type: 'FETCH_HEADER_SUCCESS',
    payload: header,
});
export const fetchImage = (image: any) => ({
    type: 'FETCH_IMAGE_SUCCESS',
    payload: image,
});
// export const image = (image: any) => ({
//     type: 'FETCH_IMAGE_SUCCESS',
//     payload: image,
// });



export const fetchProfileData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname =FNOFFICER_API .fprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetchAct(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const fetchHeaderData = (uid:any) => {
    return async (dispatch: Dispatch) => {
        try {
            const payload = {uid:uid};
            const apiname =FNOFFICER_API .fprofile;
            const response = await LoginService.getData(apiname,payload);
            dispatch(fetch(response));
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
};
export const UploadImageData = (fileToUpload:any,uid:any)=>{
    return async (dispatch:Dispatch) =>{
        try{
            // const payload = {document:fileToUpload,uid:uid};
            const apiname = FNOFFICER_API.SviewdocImage;
            //create form data and append the file
            const formData = new FormData();
            const filename = `${uid}-${fileToUpload.name}`;
            formData.append('fileToUpload',fileToUpload,filename);
            const response = await LoginService.uploadimage(apiname,formData);
            dispatch(fetchImage(response));
        }catch(error) {
            console.error('Error fetching data:', error);
        }
    };
};
// export const getProfileData = (uid:any) => {
//     return async (dispatch: Dispatch) => {
//         try {
//             const payload = {uid:uid};
//             const apiname =FNOFFICER_API .fprofile;
//             const response = await LoginService.getData(apiname,payload);
//             dispatch(fetchAct(response));
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         }
//     };
// };
